/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { Margin } from './Margin';
import type { Parameter } from './Parameter';
import type { Position } from './Position';

export type OptionType = {
    id: string;
    displayName: string;
    ghModelReference: string;
    snapClass: OptionType.snapClass;
    margin: Margin;
    defaultPosition: Position;
    defaultRotation: number;
    parameters: Array<Parameter>;
    optionFolderIds: Array<string>;
}

export namespace OptionType {

    export enum snapClass {
        ROOF = 'ROOF',
        DORMER = 'DORMER',
        WALL = 'WALL',
        OPTION = 'OPTION',
    }


}
